export default __webpack_public_path__ + "static/media/key-man.faa3e0c7.svg";